import type { Translations } from './en';

export const ta: Translations = {
  'nav.inPlay': 'இன்-ப்ளே',
  'nav.aviator': 'Aviator',

  // Bottom navigation bar
  'bottomNav.home': 'முகப்பு',
  'bottomNav.inPlay': 'நேரலை',
  'bottomNav.offers': 'சலுகைகள்',
  'bottomNav.myMarkets': 'என் மார்க்கெட்டுகள்',
  'bottomNav.referral': 'பரிந்துரை',
  'bottomNav.passbook': 'பாஸ்புக்',
  'bottomNav.profile': 'சுயவிவரம்',

  'common.deposit': 'டெபாசிட்',
  'common.withdraw': 'பணம் எடு',
  'common.rules': 'விதிகள்',
  'common.all': 'அனைத்தும்',
  'common.viewAll': 'அனைத்தையும் காண்',
  'common.loading': 'ஏற்றுகிறது...',
  'auth.login': 'உள்நுழை',
  'auth.signup': 'பதிவு செய்',

  'language.select': 'மொழியைத் தேர்ந்தெடுக்கவும்',

  'search.placeholder': 'போட்டிகள் / கேசினோ கேம்களைத் தேடுங்கள்',

  'search.short': 'தேடு',
  'search.matches': 'போட்டிகள்',
  'search.casinoGames': 'கேசினோ கேம்கள்',
  'search.searching': 'தேடுகிறது…',
  'search.noResults': '“{term}” க்கு முடிவுகள் இல்லை',
  'search.hint': 'அணி, லீக் அல்லது கேம் பெயரை முயற்சிக்கவும்.',

  'menu.accountStatement': 'கணக்கு அறிக்கை',
  'menu.betHistory': 'பந்தய வரலாறு',
  'menu.activityLogs': 'செயல்பாட்டுப் பதிவுகள்',
  'menu.casinoBetHistory': 'கேசினோ பந்தய வரலாறு',
  'menu.bonusStatement': 'போனஸ் அறிக்கை',
  'menu.referral': 'பரிந்துரை',
  'menu.setButtonValues': 'பட்டன் மதிப்புகளை அமை',
  'menu.changePassword': 'கடவுச்சொல்லை மாற்று',
  'menu.balance': 'இருப்பு',
  'menu.exposure': 'எக்ஸ்போஷர்',
  'menu.signOut': 'வெளியேறு',

  'sidebar.sports': 'விளையாட்டுகள்',
  'sidebar.casino': 'கேசினோ',
  'sidebar.soon': 'விரைவில்',
  'sidebar.noCompetitions': 'போட்டித் தொடர்கள் இல்லை',
  'sidebar.noMatches': 'போட்டிகள் இல்லை',

  'home.casinoProviders': 'கேசினோ வழங்குநர்கள்',
  'home.live': 'நேரலை',
  'home.virtual': 'விர்ச்சுவல்',
  'home.noLiveMatches': 'இப்போது நேரலைப் போட்டிகள் இல்லை',
  'home.noMatches': 'போட்டிகள் எதுவும் இல்லை',

  'sport.Cricket': 'கிரிக்கெட்',
  'sport.Football': 'கால்பந்து',
  'sport.Tennis': 'டென்னிஸ்',
  'sport.Kabaddi': 'கபடி',
  'sport.Politics': 'அரசியல்',
  'sport.Basketball': 'கூடைப்பந்து',
  'sport.Baseball': 'பேஸ்பால்',
  'sport.Table Tennis': 'டேபிள் டென்னிஸ்',
  'sport.Volleyball': 'கைப்பந்து',
  'sport.Ice Hockey': 'ஐஸ் ஹாக்கி',
  'sport.Rugby': 'ரக்பி',
  'sport.Mixed Martial Arts': 'கலப்பு தற்காப்புக் கலைகள்',
  'sport.Darts': 'டார்ட்ஸ்',
  'sport.Futsal': 'ஃபுட்சால்',
  'sport.Horse Racing': 'குதிரைப் பந்தயம்',
  'sport.Greyhound Racing': 'கிரேஹவுண்ட் பந்தயம்',

  'market.limits': 'குறைந்தபட்சம்: {min} | அதிகபட்சம்: {max}',
  'market.cashout': 'கேஷ்அவுட்',

  'menu.profile': 'சுயவிவரம்',
  'menu.transactionReport': 'பரிவர்த்தனை அறிக்கை',
  'profile.activeBets': 'செயலில் உள்ள பந்தயங்கள்',
  'profile.joinUs': 'எங்களுடன் இணையுங்கள்',
  'profile.logout': 'வெளியேறு',
  'profile.balance': 'இருப்பு',

  'profile.description':
    'உங்கள் இருப்பு, வாலட், சேமித்த கணக்குகள் மற்றும் அறிக்கைகள் ஒரே இடத்தில்.',
  'profile.exposure': 'எக்ஸ்போஷர்',
  'profile.bonus': 'போனஸ்',

  // Deposit popup
  'deposit.availableBalance': 'கிடைக்கும் இருப்பு',
  'deposit.coins': 'நாணயங்களை டெபாசிட் செய்',
  'deposit.enterCoins': 'நாணயங்களை உள்ளிடவும்',
  'deposit.makePayment': 'பணம் செலுத்து',
  'deposit.loadingMethods': 'கட்டண முறைகள் ஏற்றப்படுகின்றன...',
  'deposit.methodsError': 'கட்டண முறைகளை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  'deposit.noMethods': 'தற்போது கட்டண முறைகள் எதுவும் இல்லை.',
  'deposit.uploadScreenshot': 'கட்டண ஸ்கிரீன்ஷாட்டைப் பதிவேற்ற இங்கே கிளிக் செய்யவும்',
  'deposit.optional': '(விருப்பத்தேர்வு)',
  'deposit.utrLabel': 'தனித்துவ பரிவர்த்தனை குறிப்பு (UTR)',
  'deposit.utrPlaceholder': '6 முதல் 23 இலக்க UTR/RRN எண்',
  'deposit.txHash': 'பரிவர்த்தனை ஹாஷ்',
  'deposit.paste': 'ஒட்டு',
  'deposit.copy': 'நகலெடு',
  'deposit.submit': 'சமர்ப்பி',
  'deposit.submitting': 'சமர்ப்பிக்கிறது...',
  'deposit.scanning': 'ஸ்கிரீன்ஷாட்டிலிருந்து UTR படிக்கப்படுகிறது...',
  'deposit.scanFound':
    'உங்கள் ஸ்கிரீன்ஷாட்டிலிருந்து UTR நிரப்பப்பட்டது, அது சரியா எனச் சரிபார்க்கவும்.',
  'deposit.scanNotFound': 'ஸ்கிரீன்ஷாட்டிலிருந்து UTR-ஐப் படிக்க முடியவில்லை, அதை உள்ளிடவும்.',
  'deposit.upiId': 'UPI ஐடி',
  'deposit.name': 'பெயர்',
  'deposit.walletAddress': 'வாலட் முகவரி',
  'deposit.send': 'அனுப்பு',
  'deposit.rateUnavailable': 'மாற்று விகிதம் கிடைக்கவில்லை, பின்னர் மீண்டும் முயற்சிக்கவும்.',
  'deposit.range': '{min} முதல் {max} காயின்கள் வரை டெபாசிட் செய்யவும்',
  'deposit.rangeFrom': 'குறைந்தபட்ச டெபாசிட் {min} காயின்கள்',
  'deposit.noMethodForAmount': 'இந்தத் தொகைக்கு கட்டண முறை இல்லை. தொகையை மாற்றவும்.',
  'deposit.displayName': 'காட்சிப் பெயர்',
  'deposit.upiDetails': 'UPI விவரங்கள்',
  'deposit.bankDetails': 'வங்கி விவரங்கள்',
  'deposit.cryptoDetails': 'கிரிப்டோ விவரங்கள்',
  'deposit.bankName': 'வங்கி பெயர்',
  'deposit.accountHolderName': 'கணக்கு வைத்திருப்பவர் பெயர்',
  'deposit.accountNumber': 'கணக்கு எண்',
  'deposit.ifsc': 'IFSC குறியீடு',
  'deposit.amount': 'தொகை',
  'deposit.hashCode': 'ஹாஷ் குறியீடு',
  'deposit.enterHash': 'ஹாஷ் குறியீட்டை உள்ளிடவும்',

  // Withdraw popup
  'withdraw.coins': 'நாணயங்களை எடு',
  'withdraw.minimum': 'குறைந்தபட்ச எடுப்புத் தொகை {min} நாணயங்கள்',
  'withdraw.overBalance': 'தொகை உங்கள் கிடைக்கும் இருப்பை விட அதிகம்',
  'withdraw.continue': 'தொடரவும்',
  'withdraw.loadingAccounts': 'உங்கள் கணக்குகள் ஏற்றப்படுகின்றன...',
  'withdraw.accountsError': 'உங்கள் கணக்குகளை ஏற்ற முடியவில்லை. மீண்டும் முயற்சிக்கவும்.',
  'withdraw.noAccounts':
    'சேமித்த கணக்குகள் இல்லை. பணம் எடுக்க வங்கி, UPI அல்லது கிரிப்டோ கணக்கைச் சேர்க்கவும்.',
  'withdraw.addAccount': 'கணக்கைச் சேர்',
  'withdraw.bankAccount': 'வங்கிக் கணக்கு',
  'withdraw.cryptoWallet': 'கிரிப்டோ வாலட்',
  'withdraw.accountHolder': 'கணக்கு வைத்திருப்பவர்',
  'withdraw.accountNumber': 'கணக்கு எண்',
  'withdraw.ifsc': 'IFSC',
  'withdraw.amount': 'தொகை',
  'withdraw.youReceive': 'நீங்கள் பெறுவது',
  'withdraw.submit': 'பணம் எடு {amount}',
  'withdraw.processing': 'செயலாக்கப்படுகிறது...',
};
